import Nav from "./modules/nav.js";
import Collapse from "./modules/collapse";
import FunctionsGroup from "./modules/functions-group";
import FormRange from "./modules/form-range";
// import { initDropdowns } from "./modules/dropdown.js";
import MicroModal from "micromodal";
import CollectionSlider from "./modules/collection-slider";
import TestimonialSlider from "./modules/testimonial-slider";
import {initTouchDevice, prepositionsNbsp} from "./modules/utilities";

// Main JS file

function init() {
  // Touch device
  initTouchDevice();
  
  // Preposition + &nbsp;
  prepositionsNbsp(); // run 1
  prepositionsNbsp(); // run 2

  // Nav
  Nav();
  
  // Dropdowns
  // const dropdowns = document.querySelectorAll('.dropdown');
  // initDropdowns(dropdowns);  
  
  // Collapse
  const collapseElements = document.querySelectorAll('.collapse');
  Collapse(collapseElements);
  
  // Functions group
  const functionsGroups = document.querySelectorAll('.functions-group');
  FunctionsGroup(functionsGroups);
  
  // Collection slider
  const collectionSliders = document.querySelectorAll('[data-swiper-container="collections"]');
  CollectionSlider(collectionSliders);

  // Testimonial slider
  const testimonialSliders = document.querySelectorAll('[data-swiper="testimonials"]');
  TestimonialSlider(testimonialSliders);

  window.FormRange = FormRange;
  
  // Modal (https://www.npmjs.com/package/micromodal)
  MicroModal.init({
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
    // debugMode: true,
  });
}

window.addEventListener('DOMContentLoaded', init);
